<template>
	<div class="current-font">
	    <brand-menu></brand-menu>
      <b-container fluid="xl">
        <checkout-header title="Check ouT">
          <div>
            <!-- <span class="title-letter">C</span>
            <span style="margin-left:-7px;margin-right: -7px;">HECK OU</span>
            <span class="title-letter">T</span> -->
            Checkout
          </div>
        </checkout-header>
        <div class="container-body">
          <b-row class="contact-content">
            <!-- class="mr-4" -->
            <b-col class="pr-4" lg="12" xl="6">
              <div class="billing-address">
                <div class="contact">Billing Address</div>
                <div class="line-body">
                  <div class="triangle-left"></div>
                  <div class="line"></div>
                  <div class="triangle-right"></div>
                </div>
                <div class="form-body">
                  <div>
                    <b-form-group
                    	id="input-group-0"
                    	label="Select other address"
                    	labelClass="text-left"
                    	label-for="input-0"
                    >
                    	<b-form-select
                    		id="input-0"
                    		v-model="form.billingAddress.id"
                    		:options="billingAddressList"
                    		required
                        @change="selectChange"
                    	></b-form-select>
                    </b-form-group>
                  </div>
                  <b-row class="pt-3">
                    <b-col>
                      <b-form-group
                      	id="input-group-1"
                      	label="First Name*"
                      	labelClass="text-left"
                      	label-for="input-1"
                      >
                      	<b-form-input
                      		id="input-1"
                      		v-model="form.billingAddress.firstName"
                      		type="text"
                      		placeholder=""
                      		required
                      	></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group
                      	id="input-group-2"
                      	label="Last Name*"
                      	labelClass="text-left"
                      	label-for="input-2"
                      >
                      	<b-form-input
                      		id="input-2"
                      		v-model="form.billingAddress.lastName"
                      		type="text"
                      		placeholder=""
                      		required
                      	></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <div class="pt-3">
                    <b-form-group
                    	id="input-group-3"
                    	label="Email*"
                    	labelClass="text-left"
                    	label-for="input-3"
                    >
                    	<b-form-input
                    		id="input-3"
                    		v-model="form.billingAddress.email"
                    		type="email"
                    		placeholder=""
                    		required
                    	></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="pt-3">
                    <b-form-group
                    	id="input-group-4"
                    	label="Phone Number*"
                    	labelClass="text-left"
                    	label-for="input-4"
                    >
                    	<b-input-group>
                    		<template #prepend>
                    			<b-dropdown>
                    				<template #button-content>
                    					<span><img :src="countries[billingAreaCode].imgSrc"></span>
                    					<span>（{{ form.billingAddress.areaCode }}）</span>
                    				</template>
                    				<b-dropdown-item v-for="(item,index) in countries" :key="item.id">
                              <div @click="handleAreaCode(item.areaCode, 'billing')">
                                <span><img :src="item.imgSrc"></span>
                                <span>（{{ item.areaCode }}）</span>
                              </div>
                    				</b-dropdown-item>
                    			</b-dropdown>
                    		</template>
                    		<b-form-input
                    			id="input-4"
                    			v-model="form.billingAddress.tel"
                    			type="tel"
                    			placeholder=""
                    			required
                    		></b-form-input>
                    	</b-input-group>
                    </b-form-group>
                  </div>
                  <div class="pt-3">
                    <b-form-group
                    	id="input-group-5"
                    	label="Country*"
                    	labelClass="text-left"
                    	label-for="input-5"
                    >
                    	<b-form-select
                    		id="input-5"
                    		v-model="form.billingAddress.nationId"
                    		:options="countries"
                    		required
                    	></b-form-select>
                    </b-form-group>
                  </div>
                  <div class="pt-3">
                    <b-form-group
                    	id="input-group-6"
                    	label="Address Line 1*"
                    	labelClass="text-left"
                    	label-for="input-6"
                    >
                    	<b-form-input
                    		id="input-6"
                    		v-model="form.billingAddress.address1"
                    		type="text"
                    		placeholder=""
                    		required
                    	></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="pt-3">
                    <b-form-group
                    	id="input-group-7"
                    	label="Address Line 2*"
                    	labelClass="text-left"
                    	label-for="input-7"
                    >
                    	<b-form-input
                    		id="input-7"
                    		v-model="form.billingAddress.address2"
                    		type="text"
                    		placeholder=""
                    		required
                    	></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="pt-3">
                    <b-form-group
                    	id="input-group-8"
                    	label="City / Suburb*"
                    	labelClass="text-left"
                    	label-for="input-8"
                    >
                    	<b-form-input
                    		id="input-8"
                    		v-model="form.billingAddress.cityName"
                    		type="text"
                    		placeholder=""
                    		required
                    	></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="pt-3">
                    <b-form-group
                    	id="input-group-9"
                    	label="Zip/Postcode*"
                    	labelClass="text-left"
                    	label-for="input-9"
                    >
                    	<b-form-input
                    		id="input-9"
                    		v-model="form.billingAddress.postalCode"
                    		type="text"
                    		placeholder=""
                    		required
                    	></b-form-input>
                    </b-form-group>
                  </div>

                </div>
              </div>
              <div class="delivery-address">
                <div class="contact">Delivery Address</div>
                <div class="line-body">
                  <div class="triangle-left"></div>
                  <div class="line"></div>
                  <div class="triangle-right"></div>
                </div>
                <div class="form-body">
                  <b-form-group>
                    <b-form-radio v-model="form.custom" name="delivery" value="0">
                      Default (same as billing address)
                    </b-form-radio>
                    <b-form-radio v-model="form.custom" name="delivery" value="1" class="mt-3">
                      Add an alternative delivery address
                    </b-form-radio>
                  </b-form-group>
                  <div class="custom-delivery-address" v-show="form.custom == 1">
                    <div class="pt-3">
                      <b-form-group
                      	id="input-group-10"
                      	label="Select other address"
                      	labelClass="text-left"
                      	label-for="input-10"
                      >
                      	<b-form-select
                      		id="input-10"
                      		v-model="form.delivery.id"
                      		:options="deliveryAddressList"
                      		required
                          @change="selectChangeDeliver"
                      	></b-form-select>
                      </b-form-group>
                    </div>
                    <b-row class="pt-3">
                      <b-col>
                        <b-form-group
                        	id="input-group-11"
                        	label="First Name*"
                        	labelClass="text-left"
                        	label-for="input-11"
                        >
                        	<b-form-input
                        		id="input-11"
                        		v-model="form.delivery.firstName"
                        		type="text"
                        		placeholder=""
                        		required
                        	></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group
                        	id="input-group-12"
                        	label="Last Name*"
                        	labelClass="text-left"
                        	label-for="input-12"
                        >
                        	<b-form-input
                        		id="input-12"
                        		v-model="form.delivery.lastName"
                        		type="text"
                        		placeholder=""
                        		required
                        	></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <div class="pt-3">
                      <b-form-group
                      	id="input-group-13"
                      	label="Email*"
                      	labelClass="text-left"
                      	label-for="input-13"
                      >
                      	<b-form-input
                      		id="input-13"
                      		v-model="form.delivery.email"
                      		type="text"
                      		placeholder=""
                      		required
                      	></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="pt-3">
                      <b-form-group
                      	id="input-group-14"
                      	label="Phone Number*"
                      	labelClass="text-left"
                      	label-for="input-14"
                      >
                      	<b-input-group>
                      		<template #prepend>
                      			<b-dropdown>
                      				<template #button-content>
                      					<span><img :src='countries[deliveryAreaCode].imgSrc'></span>
                      					<span>（{{ form.delivery.areaCode }}）</span>
                      				</template>
                      				<b-dropdown-item v-for="(item,index) in countries" :key="item.id">
                                <div @click="handleAreaCode(item.areaCode, 'delivery')">
                                  <span><img :src="item.imgSrc"></span>
                                  <span>（{{ item.areaCode }}）</span>
                                </div>
                      				</b-dropdown-item>
                      			</b-dropdown>
                      		</template>
                      		<b-form-input
                      			id="input-14"
                      			v-model="form.delivery.tel"
                      			type="tel"
                      			placeholder=""
                      			required
                      		></b-form-input>
                      	</b-input-group>
                      </b-form-group>
                    </div>
                    <div class="pt-3">
                      <b-form-group
                      	id="input-group-15"
                      	label="Country*"
                      	labelClass="text-left"
                      	label-for="input-15"
                      >
                      	<b-form-select
                      		id="input-5"
                      		v-model="form.delivery.nationId"
                      		:options="countries"
                      		required
                      	></b-form-select>
                      </b-form-group>
                    </div>
                    <div class="pt-3">
                      <b-form-group
                      	id="input-group-16"
                      	label="Address Line 1*"
                      	labelClass="text-left"
                      	label-for="input-16"
                      >
                      	<b-form-input
                      		id="input-16"
                      		v-model="form.delivery.address1"
                      		type="text"
                      		placeholder=""
                      		required
                      	></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="pt-3">
                      <b-form-group
                      	id="input-group-17"
                      	label="Address Line 2*"
                      	labelClass="text-left"
                      	label-for="input-17"
                      >
                      	<b-form-input
                      		id="input-17"
                      		v-model="form.delivery.address2"
                      		type="text"
                      		placeholder=""
                      		required
                      	></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="pt-3">
                      <b-form-group
                      	id="input-group-18"
                      	label="City / Suburb*"
                      	labelClass="text-left"
                      	label-for="input-18"
                      >
                      	<b-form-input
                      		id="input-18"
                      		v-model="form.delivery.cityName"
                      		type="text"
                      		placeholder=""
                      		required
                      	></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="pt-3">
                      <b-form-group
                      	id="input-group-19"
                      	label="Zip/Postcode*"
                      	labelClass="text-left"
                      	label-for="input-19"
                      >
                      	<b-form-input
                      		id="input-19"
                      		v-model="form.delivery.postalCode"
                      		type="text"
                      		placeholder=""
                      		required
                      	></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="pt-3">
                      <b-form-group>
                         <b-form-radio-group
                              v-model="form.isNewDelivery"
                              :options="options"
                              name="radio-inline"
                              ></b-form-radio-group>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </div>
              <div class="shipping-method">
                <div class="contact">Shipping Method</div>
                <div class="line-body">
                  <div class="triangle-left"></div>
                  <div class="line"></div>
                  <div class="triangle-right"></div>
                </div>
                <div class="form-body">
                  <b-row>
                    <b-col>
                      <b-form-group>
                        <b-form-radio v-model="form.shippingMethod" value="0">Free</b-form-radio>
                      </b-form-group>
                    </b-col>
                    <b-col>Express Courier (Air)</b-col>
                    <b-col>3 to 4 business days</b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
            <b-col class="pr-4" lg="12" xl="6">
              <div>
                <div class="contact">Total({{payGoodList.length}})</div>
                <div class="line-body">
                  <div class="triangle-left"></div>
                  <div class="line"></div>
                  <div class="triangle-right"></div>
                </div>
                <div>
                  <ul>
                    <li class="" v-for="(item,index) in payGoodList" :key="index">
                      <b-row class="total-content">
                        <b-col class="d-flex justify-content-end">
                          <img :src="item.picUrl" alt="" style="width:150px;height:150px">
                        </b-col>
                        <b-col>
                          <div class="brand">{{ item.brandName }}</div>
                          <div class="name">{{ item.goodsName }}</div>
                          <div class="sku">{{ item.serialNumber }}</div>
                        </b-col>
                        <b-col class="d-flex justify-content-center name">
                          <span>HK$ </span>
                          <span v-if="item.webPrice">{{ item.webPrice }}.</span>
                          <span v-else>{{ item.originalPrice }}.</span>
                          <span class="decimal">00</span>
                        </b-col>
                      </b-row>
                      <div class="inner-line" v-if="index < payGoodList.length-1"></div>
                    </li>
                  </ul>
                </div>
              </div>
              <div>
                <div class="line-body">
                  <div class="triangle-left"></div>
                  <div class="line"></div>
                  <div class="triangle-right"></div>
                </div>
                <div class="inner-line">
                  <div class="total-price mt-2">
                    <div>Subtotal</div>
                    <div>
                     HK${{subtotal}}
                      <span class="decimal">.00</span>
                    </div>
                  </div>
                </div>
                <div class="inner-line">
                  <div class="total-price">
                    <div>Shipping Cost</div>
                    <div>
                      HK$ {{freightPrice}}.
                      <span class="decimal">00</span>
                    </div>
                  </div>
                </div>
                <div class="inner-line">
                  <div class="total-price">
                    <div>VAT/GST</div>
                    <div>
                      HK$ 0.
                      <span class="decimal">00</span>
                    </div>
                  </div>
                </div>
                <div class="total-summary">
                  <div class="total-summary-price font-weight-bold">
                    <div>Total Price</div>
                    <div class="final-price">
                      HK${{totalPrice}}
                      <span class="decimal">.00</span>
                    </div>
                  </div>
                  <div class="total-summary-price">
                    <div>In the payment currency</div>
                    <div class="font-weight-bold">
                      ≈US$ {{usPrice}}.
                      <span class="decimal">00</span>
                    </div>
                  </div>
                </div>
                <div class="promo">
                  <div class="promo-bg">
                    <div class="promo-body">Add a promo code.</div>
                  </div>
                </div>
                <div class="promo">
                  International shoppers are required to pay customs charges as well as any associated import tax, VAT,
                  or duties as required by your local jurisdiction. Contact your Client Advisor or read more
                  <a class="link" href="javascript:;">ABOUT SHIPPING</a>.
                </div>
              </div>
            </b-col>
          </b-row>
          <div class="submit-body">
            <b-row>
              <b-col cols="3">
                <b-button variant="dark" block @click="handleNextPayment()">NEXT: PAYMENT</b-button>
              </b-col>
              <b-col cols="9"></b-col>
            </b-row>
          </div>
        </div>
      </b-container>
  </div>
</template>

<script>
import { creatOrder,selectCarList,queryCarByString } from '@/api/order'
import BrandMenu from "@/components/BrandMenu";
import CheckoutHeader from "@/components/CheckoutHeader";

import {queryCarByUserId,queryUserAddressList,queryUserAddress,createAddress ,queryUserDeliverList} from '@/api/checkOut';

import { setBuy,getBuy,removeBuy } from "../utils/auth";

export default {
  name: "CheckoutView",
  components: {
    BrandMenu,
    CheckoutHeader
  },
  data() {
    return {
      form: {
        billingAddress: {
          id: undefined,
          firstName: undefined,
          lastName: undefined,
          email: undefined,
          areaCode: '+852',
          tel: undefined,
          nationId: undefined,
          address1: undefined,
          address2: undefined,
          cityName: undefined,
          postalCode: undefined,
        },
        custom: 0,
        delivery: {
            id: 0,
            firstName: undefined,
            lastName: undefined,
            email: undefined,
            areaCode: '+852',
            tel: undefined,
            nationId: undefined,
            address1: undefined,
            address2: undefined,
            cityName: undefined,
            postalCode: undefined,
        },
        shippingMethod: 0,
        isNewDelivery: 1,
        areaCode: '+852',
      },
      billingAddressList: [],
      deliveryAddressList: [],
      payGoodList: [],
      countries: [],
      userId:undefined,
      subtotal:undefined,
      usPrice:undefined,
      totalPrice:undefined,
      orderSn:undefined,
      freightPrice:undefined,
      options: [
                { text: 'Save as new delivery address', value: '1' },
                { text: 'Not Save', value: '0' },
              ],
      billingAreaCode: 0,
      deliveryAreaCode: 0,
    }
  },
  created() {
    //判断是否已经登录 未登录跳转登录界面
    if(!this.$store.getters.userId){
       this.$router.push('/login')
       return
    }else{
       this.userId=this.$store.getters.userId
       this.form.userId=this.userId
       queryCarByUserId(this.userId).then(response=>{
         console.log(response.data.data)
         this.payGoodList=response.data.data.goodsCarList
         this.subtotal=response.data.data.webPrice
         this.usPrice=response.data.data.usPrice
         this.freightPrice=response.data.data.freightPrice
         this.totalPrice=response.data.data.totalPrice
       })

       queryUserAddressList(this.userId).then(response=>{
         console.log(response.data.data.addressList)
         this.billingAddressList=response.data.data.addressList
         this.form.billingAddress.id = this.billingAddressList[0].value;
         if (this.form.billingAddress.id !=0) {
           this.findAddress(this.form.billingAddress.id,1);
         }
       })

       queryUserDeliverList(this.userId).then(response=>{
         console.log(response.data.data.addressList)
         this.deliveryAddressList=response.data.data.addressList
         this.form.delivery.id = this.deliveryAddressList[0].value;
         if (this.form.delivery.id !=0) {
           this.findAddress(this.form.delivery.id,2);
         }
       })
    }




    this.deliveryAddressList = [
      {value: 0, text: 'Add a new address'},
      {value: 1, text: 'home'},
      {value: 2, text: 'company'},
    ];
    this.payGoodList = [
      {id:1, src:require("@/assets/xh/images/checkout1.png"), brand:'Omega', name:'Constellation', sku:'SKU#4568910', price:'180,000,000'},
      {id:2, src:require("@/assets/xh/images/checkout1.png"), brand:'Omega', name:'Constellation', sku:'SKU#4568910', price:'180,000,000'},
    ];
    this.countries = [
      {value: 155, text: '中国香港', areaCode: '+852', imgSrc: require('@/assets/xh/images/hk.png')},
      {value: 159, text: '中国', areaCode: '+86', imgSrc: require('@/assets/xh/images/zg.png')},
      {value: 161, text: '中国台湾', areaCode: '+886', imgSrc: require('@/assets/xh/images/tw.png')},
    ]
    // this.init()

  },
  methods: {
    handleNextPayment(event) {
      if (this.form.custom == 0){
        this.form.delivery=this.form.billingAddress
        createAddress(this.form)
          .then(response => {
            this.orderSn = response.data.data.data.orderSn;
            this.$message.success('创建成功')
            console.log( this.orderSn)
            this.$router.push({
              name: 'payment',
              params: {
                userId: this.userId,
                orderSn:this.orderSn,
              }
            })
          })
          .catch(error => {

          })
      }
    },
    init(){
      var userId=this.$store.getters.userId
      if(userId){
        console.log('已登录')
        selectCarList(60).then(response=>{
          console.log('查询购物车')
          console.log(response.data.data)
          this.payGoodList=response.data.data
        })
      }else{
         console.log('未登录')
        var gids= getBuy()
         if(gids){
           queryCarByString(gids).then(res=>{
             console.log(res.data.data)
            this.payGoodList=res.data.data
           })
         }
      }
    },

    selectChange(val) {
      if (this.form.billingAddress.id == 0) {
        console.log('首次添加')
        for(let k in this.form.billingAddress){
          this.form.billingAddress[k]=undefined
        }
        this.form.billingAddress.id=0
      } else {
        this.findAddress(val,1);
      }
    },

    selectChangeDeliver(val){
      if (this.form.delivery.id == 0) {
        console.log('首次添加')
        for(let k in this.form.delivery){
          this.form.delivery[k]=undefined
        }
        this.form.delivery.id=0
      } else {
        this.findAddress(val,2);
      }
    },

    findAddress(val,addressType){
      queryUserAddress(val).then(response=>{
        console.log(response.data.data)
        if (addressType== 1) {
            this.form.billingAddress.cityName = response.data.data.cityName,
            this.form.billingAddress.firstName = response.data.data.firstName,
            this.form.billingAddress.lastName = response.data.data.lastName,
            this.form.billingAddress.email = response.data.data.email,
            this.form.billingAddress.tel = response.data.data.tel,
            this.form.billingAddress.nationId = response.data.data.nationId,
            this.form.billingAddress.address1 = response.data.data.address1,
            this.form.billingAddress.address2 = response.data.data.address2,
            this.form.billingAddress.postalCode = response.data.data.postalCode
            this.form.billingAddress.areaCode = response.data.data.crmId

        } else {
            this.form.delivery.cityName = response.data.data.cityName,
            this.form.delivery.firstName = response.data.data.firstName,
            this.form.delivery.lastName = response.data.data.lastName,
            this.form.delivery.email = response.data.data.email,
            this.form.delivery.tel = response.data.data.tel,
            this.form.delivery.nationId = response.data.data.nationId,
            this.form.delivery.address1 = response.data.data.address1,
            this.form.delivery.address2 = response.data.data.address2,
            this.form.delivery.postalCode = response.data.data.postalCode
            this.form.delivery.areaCode = response.data.data.crmId
        }

      })
    },

    handleAreaCode(val, pos) {
      let cur = 0;
      switch (val) {
        case '+852':
          cur = 0
          break
        case '+86':
          cur = 1
          break
        case '+886':
          cur = 2
          break
      }

      if (pos == 'billing') {
        this.form.billingAddress.areaCode = val
        this.billingAreaCode = cur
      } else if (pos == 'delivery') {
        this.form.delivery.areaCode = val
        this.deliveryAreaCode = cur
      }
    }
  }
}
</script>

<style scoped>
  .f_spec_sc-R {
      font-family: 'spectral_sc-R';
  }
  .current-font {
    font-family: SourceHanSansCN-ExtraLight;
    font-weight: 250;
  }
  input, select {
    font-family: SourceHanSansCN-ExtraLight;
    font-weight: normal;
  }
  .title-letter {
    font-size: 32px;
  }
  .container-body {
    padding: 5rem 5.5rem 6rem 5.5rem;
  }
  .contact-content {
  	margin: 0 1rem;
  }
  .contact-content .form-body {
    padding: 2rem 2rem;
  }
  .contact-content .form-body input {
    border: 1px solid black;
  }
  .form-body #input-4, .form-body #input-14 {
    border: none;
  }
  .form-body .input-group {
    border: 1px solid black;
  }
  .form-body .custom-select {
		border: 1px solid black;
		background: #fff url("../../public/img/viawatch/icon/pull-bottom.png") no-repeat right 0.75rem center;
	}
  /* 前导深度替换样式 */

.custom-radio .custom-control-label {
    padding-top: 3.5px;
  }
  .contact-content .contact {
  	display: flex;
  	justify-content: flex-start;
  	font-size: 24px;
    margin-bottom: 0.5rem;
  }
  .contact-content .line-body {
  	height: 1px;
  	display: flex;
  }
  .contact-content .line {
  	height: 1px;
  	background: black;
  	display: flex;
  	flex-basis: 100%;
  	margin-top: 4.4px;
  	margin-left: -8px;
  	margin-right: -8px;
  }
  .contact-content .triangle-left {
  	width: 0;
  	height: 0;
  	border: 5px solid;
  	border-color: transparent transparent transparent black;
  }
  .contact-content .triangle-right {
  	width: 0;
  	height: 0;
  	border: 5px solid;
  	border-color: transparent black transparent transparent;
  }

  .total-line {
    border-bottom: 1px solid black;
  }
  .total-content {
    padding: 2rem 0;
  }
  .total-content .brand {
    color: #072D79;
  }
  .total-content .name {
    font-size: 1.25rem;
    font-weight: bold;
  }
  .total-content .sku {
    color: #979797;
  }
  .decimal {
    font-weight: normal;
    font-size: 1rem;
    margin-top: 0.25rem;
  }
  .total-price {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.125rem;
    font-weight: bold;
    padding: 1rem 3rem;
  }
  .inner-line {
    border-bottom: 1px solid #969696;
  }
  .total-summary {
    padding: 4.25rem 3rem;
  }
  .total-summary .total-summary-price {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.25rem;
    margin-bottom: 0.6rem;
  }
  .total-summary .final-price {
    font-size: 1.5rem;
  }
  .promo {
    padding: 0 2.5rem;
    margin-bottom: 3rem;
    cursor: default;
  }
  .promo .promo-bg {
    height: 4.5rem;
    background-color: #E0E0E0;
    display: flex;
    align-items: center;
  }
  .promo .promo-body {
    padding-left: 2rem;
    font-size: 1.5rem;
  }
 .promo .link {
    text-decoration: underline;
    cursor: pointer;
  }
  .payment {
    border: none;
  }

   .payment .card-header {
    background-color: white;
    border-bottom: none;
  }
   .payment .payment-title {
    padding: 0;
    margin: 0.25rem 0.75rem;
    border: 1px solid #5F5F5F;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }



 .payment .payment-title-link {

    padding: 0;
    margin: 0.25rem 0.75rem;
    border-color: #24385D;
    border: 2px solid #24385D;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

 .nav-tabs .nav-link.active {

    border-color: #24385D #24385D #24385D #24385D;
  }
  .payment .payment-body {
    margin-left: -1.5rem;
    font-weight: 250;
  }

  .submit-body {
  	padding-top: 3.6rem;
  	font-size: 18px;
  }
  .submit-body .btn {
    font-family: SourceHanSansCN-ExtraLight;
  	font-size: 18px;
    font-weight: 250;
    background-color: black;
    min-width: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/views/CheckoutView.vue